/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const VEHICLES_GRID_CODE = 'customer-vehicles-list';
export const VEHICLES_OWNERSHIP_GRID_CODE = 'customer-vehicles-ownership';
